import React from 'react'
import { createRoot } from 'react-dom/client'
import ExternalApp from './app/ExternalApp'
import * as serviceWorker from './serviceWorker'
import 'typeface-roboto'
import {
  RichSelectModule,
  SetFilterModule,
  StatusBarModule,
  ClipboardModule,
  ColumnsToolPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  ExcelExportModule,
  MenuModule,
  FiltersToolPanelModule,
  RangeSelectionModule,
  LicenseManager,
  ModuleRegistry,
} from 'ag-grid-enterprise'
import { 
  ClientSideRowModelModule,   
} from 'ag-grid-community'
import { AG_GRID_LICENSE_KEY } from 'apex-ui-kit-pcn'

// Import AG Grid license key
LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY)
ModuleRegistry.registerModules([
  RichSelectModule,
  SetFilterModule,
  StatusBarModule,
  ClipboardModule,
  ColumnsToolPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  ExcelExportModule,
  MenuModule,
  FiltersToolPanelModule,
  RangeSelectionModule,
  ClientSideRowModelModule,  
])

const root = createRoot(document.getElementById('root'))
root.render(<ExternalApp />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
